import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { parse } from 'date-fns';

@Pipe({
    name: 'serializedDate'
})
export class SerializedDatePipe implements PipeTransform {
    constructor(private _datePipe: DatePipe) {}

    public transform(
        val: string | number,
        format?: string,
        timezone?: string,
        locale?: string
    ): string {
        const date = typeof val === 'string' ? parse(val) : new Date(val);
        return this._datePipe.transform(date, format, timezone, locale);
    }
}
